export default __webpack_public_path__ + "static/media/device.f2c31b3f.svg";